import { drizzle } from 'drizzle-orm/postgres-js'
import postgres from 'postgres'
import * as schema from './schema'

const connectionString = process.env.DATABASE_URL!

function parsePositiveInteger(value: string | undefined) {
  if (!value) return null
  const parsed = Number(value)
  return Number.isInteger(parsed) && parsed > 0 ? parsed : null
}

function getMaxConnections() {
  const configured = parsePositiveInteger(process.env.DB_MAX_CONNECTIONS)
  if (configured) return configured
  if (process.env.NODE_ENV === 'test') return 1
  if (process.env.NODE_ENV === 'development') return 3
  return 1
}

function getIdleTimeoutSeconds() {
  const configured = parsePositiveInteger(process.env.DB_IDLE_TIMEOUT_SECONDS)
  if (configured) return configured
  if (process.env.NODE_ENV === 'test') return 1
  if (process.env.NODE_ENV === 'development') return 20
  return 60
}

// Disable prefetch for serverless environments (Next.js edge/serverless functions)
const client = postgres(connectionString, {
  prepare: false,
  max: getMaxConnections(),
  idle_timeout: getIdleTimeoutSeconds(),
})

export const db = drizzle(client, { schema })
export type Database = typeof db
